import { styled } from "styled-components";

export const Wrapper = styled.div<{
  $showRightButton: boolean;
  $showLeftButton: boolean;
}>`
  flex: 1;
  position: relative;
  width: 100%;

  @media (max-width: 768px) {
    ${({ $showLeftButton }) =>
      $showLeftButton &&
      `
        &:before {
          position: absolute;
          top: 0;
          left: 0;
          width: 40px;
          height: 100%;
          content: "";
          background: linear-gradient(270deg, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 100%);
          pointer-events: none; 
        }
          
    `}

    ${({ $showRightButton }) =>
      $showRightButton &&
      `
        &:after {
          position: absolute;
          top: 0;
          right: 0;
          width: 40px;
          height: 100%;
          content: "";
          background: linear-gradient(90deg, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 100%);
           pointer-events: none; 
        }
    `}
  }
`;

export const Breadcrumb = styled.div`
  scroll-snap-type: x mandatory;
  overflow-x: scroll;
  display: flex;
  font-size: ${({ theme }) => theme.fonts.sm.fontSize};
  margin: 0 ${({ theme }) => theme.spacing[5]};
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }

  @media (max-width: 768px) {
    margin: 0;
    width: 100%;
  }
`;

export const BreadcrumbLink = styled.span<{
  $active: boolean;
  $disabled: boolean;
}>`
  display: flex;
  align-items: center;

  color: ${({ theme, $active, $disabled }) =>
    $active
      ? theme.colors.text.primary.color
      : $disabled
        ? theme.colors.text.tertiary.color
        : theme.colors.text.secondary.color};
  transition: color 0.2s ease-in-out;
  cursor: ${({ $disabled }) => ($disabled ? "default" : "pointer")};
  white-space: nowrap;
  height: 34px;

  ${({ theme, $disabled }) =>
    !$disabled &&
    `
      &:hover {
        color: ${theme.colors.text.primary.color};
      }
    `}
`;

export const BreadcrumbSeparator = styled.div`
  display: flex;
  align-items: center;
  padding: 0 ${({ theme }) => theme.spacing[1]};
  color: ${({ theme }) => theme.colors.text.secondary.color};

  svg {
    width: 16px;
    height: 16px;
    fill: currentColor;
  }
`;

export const NextButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: -${({ theme }) => theme.spacing[3]};
  width: ${({ theme }) => theme.spacing[5]};
  min-width: ${({ theme }) => theme.spacing[5]};
  height: ${({ theme }) => theme.spacing[5]};
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.background.layers[600]};
  z-index: 10;
`;

export const PreviousButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: -${({ theme }) => theme.spacing[3]};
  width: ${({ theme }) => theme.spacing[5]};
  min-width: ${({ theme }) => theme.spacing[5]};
  height: ${({ theme }) => theme.spacing[5]};
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.background.layers[600]};
  z-index: 10;
`;
